<template>
  <div class="main-daily app-container" v-loading="httpLoading">
    <div class="main-daily-title flex-between">
      <h1>秒杀</h1>
      <div class="all" @click="gotoCommodityPage">
        {{ $t('message.home.more' /**更多 */) }}
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="main-daily-content" ref="mainSeckill">
      <EsProductView v-for="(item,index) in seckillsList" :key="index + Math.random()" :item="item.goods" />
    </div>
    <!-- <swiper :options="swiperOptions">
      <swiper-slide v-for="(item, index) in list" :key="index">
        <div class="main-daily-item flex-center">
          <div class="img-content">
            <img :src="item" alt="" />
          </div>
          <span class="amount">$12.00</span>
        </div>
      </swiper-slide>
    </swiper> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EsProductView from '@/components/product'
import Bus from '@/util/bus'
import {
		list
	} from "@/api/marketing/seckill_marketing.js"

export default {
  name: 'EsMainSeckill',
  components: { EsProductView },
  data() {
    return {
      httpLoading: false,
      nowHours: null,
				nowMinutes: null,
				nowSeconds: null,
				hours: 0, //时
				minutes: 59, //分
				seconds: 59, //秒
				countdown: '00:59:59', //倒计时
				timer: null, //重复执行
				//秒杀请求时间场次
				seckillHours: [{
					time: '0:00',
					status: 0,
					hour: 'ZERO',
				}, {
					time: '1:00',
					status: 1,
					hour: 'ONE',
				}, {
					time: '2:00',
					status: 2,
					hour: 'TWO',
				}, {
					time: '3:00',
					status: 3,
					hour: 'THREE',
				}, {
					time: '4:00',
					status: 4,
					hour: 'FOUR',
				}, {
					time: '5:00',
					status: 5,
					hour: 'FIVE',
				}, {
					time: '6:00',
					status: 6,
					hour: 'SIX',
				}, {
					time: '7:00',
					status: 7,
					hour: 'SEVEN',
				}, {
					time: '8:00',
					status: 8,
					hour: 'EIGHT',
				}, {
					time: '9:00',
					status: 9,
					hour: 'NINE',
				}, {
					time: '10:00',
					status: 10,
					hour: 'TEN',
				}, {
					time: '11:00',
					status: 11,
					hour: 'ELEVEN',
				}, {
					time: '12:00',
					status: 12,
					hour: 'TWELVE',
				}, {
					time: '13:00',
					status: 13,
					hour: 'THIRTEEN',
				}, {
					time: '14:00',
					status: 14,
					hour: 'FOURTEEN',
				}, {
					time: '15:00',
					status: 15,
					hour: 'FIFTEEN',
				}, {
					time: '16:00',
					status: 16,
					hour: 'SIXTEEN',
				}, {
					time: '17:00',
					status: 17,
					hour: 'SEVENTEEN',
				}, {
					time: '18:00',
					status: 18,
					hour: 'EIGHTEEN',
				}, {
					time: '19:00',
					status: 19,
					hour: 'NINETEEN',
				}, {
					time: '20:00',
					status: 20,
					hour: 'TWENTY',
				}, {
					time: '21:00',
					status: 21,
					hour: 'TWENTY_ONE',
				}, {
					time: '22:00',
					status: 22,
					hour: 'TWENTY_TWO',
				}, {
					time: '23:00',
					status: 23,
					hour: 'TWENTY_THREE',
				}],
				seckillTags: [],
				//秒杀请求参数
				seckillQueryParams: {
					pageNumber: '1',
					pageSize: '5',
					hour: 'ZERO',
				},
				seckillsList: [], //秒杀
				seckillable: true,
    }
  },
  computed: {
    ...mapGetters('home', ['newList']),
  },
  methods: {
    // ...mapActions('home', ['requestRecommendLList', 'requestRecommendNewLList']),
    gotoCommodityPage() {
      this.$router.push('/commodity')
    },
    async getList(){
      try {
      this.httpLoading = true
    //   await this.requestRecommendNewLList({ type: 0 ,pageSize: 24,
    //       pageNum: 1,})
    } finally {
      this.$Gsap.from(this.$refs.mainDaily,{
        delay: 0.5,
        duration: 1,
        y: '+100',
        autoAlpha: 0,
        ease: "back.out(1.7)"
      })
      this.httpLoading = false
    }
    },

    //秒杀初始化
			seckillInit() {
				let now = new Date();
				let nowHour = now.getHours();
				// let nowHour = 0;
				this.nowHours = nowHour;
				let overHour = (24 - nowHour);
				this.seckillQueryParams.hour = this.seckillHours[nowHour].hour;
				if (this.tabTimes.length < 4) {
					for (let i = 0; i < 4; i++) {
						let timei = {};
						if (i == 0) {
							timei = {
								id: 1 + i,
								time: (nowHour + i) + ':00',
								name: this.messages['shop_seckill_marketing_underway'],
							}
						} else {
							if (nowHour + i < 24) {
								timei = {
									id: 1 + i,
									time: (nowHour + i) + ':00',
									name: this.messages['shop_seckill_marketing_willStart'],
								}
							} else {
								timei = {
									id: 1 + i,
									time: (i - overHour) + ':00',
									name: this.messages['shop_seckill_marketing_willStart'],
								}
							}

						}
						this.tabTimes.push(timei);
					}
				}

				for (let i = 0; i < 4; i++) {
					if ((nowHour + i) < 24) {
						this.seckillTags.push(this.seckillHours[nowHour + i]);
					} else {
						this.seckillTags.push(this.seckillHours[i - overHour]);
					}
				}
				this.minutes = 59 - now.getMinutes();
				this.seconds = 60 - now.getSeconds();
				this.timer = setInterval(() => {
					this.timeCount()
				}, 1000);
				this.seckill_list();
			},
			// 倒计时
			timeCount() {
				--this.seconds;
				if (this.seconds <= 0) {
					--this.minutes;
					this.seconds = 59;
				}
				if (this.minutes <= 0) {
					--this.hours;
					this.minutes = 59
				}
				if (this.hours < 0) {
					this.hours = 0;
					this.seconds = 59;
					this.minutes = 59;
				}
				this.countdown = this.hours + ":" + this.minutes + ":" + this.seconds;
			},


    /**
     * 秒杀查询列表 list
     */
      seckill_list() {
      list(this.seckillQueryParams).then(response => {
        //下拉加载
        this.seckillsList = response.data.data;
      });
    },

  },
   mounted() {
    //  Bus.$on('cancelKeep', (id)=>{
    //     const i = this.newList.findIndex(x => x.id == id)
    //     if(i>-1){
    //         this.getList()
    //     }
    //   })
    //   Bus.$on('keepProduct', (id)=>{
    //     const i = this.newList.findIndex(x => x.id == id)
    //     if(i>-1){
    //         this.getList()
    //     }
    //   })
    // this.getList()
    this.seckill_list();
  },
}
</script>

<style lang="scss">
.main-daily {
  margin-bottom: 26px;
  &-title {
    h1 {
      font-weight: 700;
      font-size: 16px;
      color: var(--color-grey);
      margin: 24px 0;
    }
    span {
      color: var(--color-main);
      font-size: 12px;
    }
    .all {
      font-size: 12px;
      color: var(--color-main);
      cursor: pointer;
      font-weight: 400;
    }
  }
  &-item {
    flex-direction: column;
    .img-content {
      width: 100%;
      margin-bottom: 10px;
    }
    .amount {
      font-size: 16px;
      font-weight: 500;
      color: var(--color-main);
    }
  }
  &-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(228px, 190px));
    grid-column-gap: 14px;
    grid-row-gap: 20px;
    align-content: center;
    /* padding: 26px 0; */
  }
  // .swiper-container {
  //   cursor: pointer;
  //   font-size: 12px;
  //   img {
  //     max-width: 310px;
  //     max-height: 148px;
  //     object-fit: cover;
  //     width: 100%;
  //     height: 100%;
  //   }
  // }
}
</style>
